import React, { useState, useEffect } from "react";
import { sixYardAxios } from "../../../sixYardAxios";
import { useNavigate } from "react-router";
import classes from "./campRegistrationForm.module.css";
import Step1 from "../../../assets/images/form-step.png";
import Step2 from "../../../assets/images/step2.png";
import Step3 from "../../../assets/images/step3.png";
import FinalStep from "../../../assets/images/form-final-step.png";
import Package from "./package/package";
import LegalInfo from "./legalInfo/legalInfo";
import Waiver from "./waiver/waiver";
import Checkout from "./checkout/checkout";

const CampRegistrationForm = (props) => {      
    const navigate = useNavigate();  
    const [currentStep, setCurrentStep] = useState(1);
    const [registrationId, setRegistrationId] = useState(null);
    const [bookingData, setBookingData] = useState({});
    const [paymentData, setPaymentData] = useState({});
    const [extraServices, setExtraServices] = useState([]);
    const [packages, setPackages] = useState([]);

    useEffect(() => {
        fetchCamp();
    }, []);
    useEffect(() => {
        fetchCamp();
    }, [props.camp.toLowerCase()]);
    const fetchCamp = async () => {
        try {
            const res = await sixYardAxios.get("/camps/" + props.camp.toLowerCase());
            setExtraServices(res.data.data.extra_services);
            setPackages(res.data.data.packages);
        } catch (error) { }
    };
    const linkClicked = () => {
        navigate("/camps/"+ props.camp.toLowerCase()+ "-camp");
        props.setShowCampRegistrationForm && props.setShowCampRegistrationForm(false);
    }
    return (
        <div className={classes.Container}>
            <div className={classes.Path}>
                <span onClick={linkClicked}>{props.camp} Camp </span>
                 / {props.camp} Camp Registration Form</div>
            <div className={classes.FormContainer}>
                <h1>{props.camp} Camp Registration Form</h1>
                <div className={classes.Steps}>
                    <img src={currentStep === 1 ? Step1 : currentStep === 2 ? Step2 : currentStep === 3 ? Step3 : FinalStep} alt='step' />
                    <div className={classes.StepsTitle}>
                        <h3 className={[currentStep === 1 && classes.CurrentStep, currentStep > 1 && classes.DoneStep].join(" ")}>
                            Package
                        </h3>
                        <h3 className={[currentStep === 2 && classes.CurrentStep, currentStep > 2 && classes.DoneStep, currentStep < 2 && classes.NextStep].join(" ")}>
                            Legal Info
                        </h3>
                        <h3 className={[currentStep === 3 && classes.CurrentStep, currentStep > 3 && classes.DoneStep, currentStep < 2 && classes.NextStep].join(" ")}>
                            Waiver
                        </h3>
                        <h3 className={[currentStep === 4 && classes.CurrentStep, currentStep < 4 && classes.NextStep].join(" ")}>
                            Checkout
                        </h3>
                    </div>
                </div>
                <div>
                    {currentStep === 1 ? <Package setRegistrationId={setRegistrationId} setBookingData={setBookingData}
                        setCurrentStep={setCurrentStep} currentStep={currentStep} extraServices={extraServices}
                        packages={packages} camp={props.camp}
                    // academy={props.academy} plans={props.plans} 
                    selectedPlan={props.selectedPlan} 
                    /> :
                        currentStep === 2 ? <LegalInfo setRegistrationId={setRegistrationId} setBookingData={setBookingData}
                            setCurrentStep={setCurrentStep} currentStep={currentStep} registrationId={registrationId}
                        //plans={props.plans} selectedPlan={props.selectedPlan} 
                        /> :
                            currentStep === 3 ? <Waiver registrationId={registrationId} setPaymentData={setPaymentData}
                                setCurrentStep={setCurrentStep} currentStep={currentStep} /> :
                                currentStep === 4 && <Checkout registrationId={registrationId} paymentData={paymentData}
                                    setCurrentStep={setCurrentStep} currentStep={currentStep} bookingData={bookingData}
                                    setShowCampRegistrationForm={props.setShowCampRegistrationForm}
                                />}
                </div>
            </div>
        </div>
    )
}

export default CampRegistrationForm;